<template>
    <div class="dzDriverDetail">
        <div class="baseinfo box">
            <div class="info-header">
                <div class="info-header-left">
                    <div class="avatar">
                        <el-image style="width: 40px; height: 40px;" :src="mixinQiniuImg(driverInfo.headPortrait)"
                            alt="司机头像" />
                    </div>
                    <div class="name">{{ driverInfo.name }}</div>
                </div>

                <el-button type="primary" @click="showDzCreate = true">
                    修改司机信息
                </el-button>
            </div>
            <el-descriptions :column="1" size="medium" border>
                <el-descriptions-item label="手机号码">{{ driverInfo.phone || '-' }}</el-descriptions-item>
                <el-descriptions-item label="状态标签">
                    <div class="status-tag">
                        <el-tag :type="driverInfo.isEnable === 1 ? 'success' : 'danger'" size="mini">{{
                            driverInfo.isEnable === 1 ? '账号正常' : '账号封禁' }}</el-tag>
                        <el-tag type="danger" v-if="$utils.checkValidity(driverInfo.idCardValid) < 0">身份证已过期</el-tag>
                        <el-tag type="warning"
                            v-else-if="$utils.checkValidity(driverInfo.idCardValid) < 30">身份证即将过期</el-tag>
                        <el-tag type="danger"
                            v-if="$utils.checkValidity(driverInfo.driverLicenceValid) < 0">驾驶证已过期</el-tag>
                        <el-tag type="warning"
                            v-else-if="$utils.checkValidity(driverInfo.driverLicenceValid) < 30">驾驶证即将过期</el-tag>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item label="机构名称">{{ driverInfo.organizationName || '-' }}</el-descriptions-item>
                <el-descriptions-item label="所属公司">{{ driverInfo.companyName || '-' }}</el-descriptions-item>
                <el-descriptions-item label="设备信息">{{ driverInfo.device || '-' }} | {{ driverInfo.appVersion || '-'
                    }}</el-descriptions-item>
                <el-descriptions-item label="紧急联系人">{{ driverInfo.emergency || '-' }}</el-descriptions-item>
                <el-descriptions-item label="紧急联系电话">{{ driverInfo.emergencyPhone || '-' }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions :column="1" size="medium" border>
                <el-descriptions-item label="绑定车辆">
                    <licensePlate v-if="driverInfo.licenseNo" :licenseNo="driverInfo.licenseNo"
                        :licenseColor="driverInfo.licenseColor" :vehicleSeat="driverInfo.vehicleSeat"></licensePlate>
                    <span v-else>暂未绑定车辆</span>
                </el-descriptions-item>
                <el-descriptions-item label="车辆型号">{{ driverInfo.vehicleModel || '-' }}</el-descriptions-item>
                <el-descriptions-item label="车辆颜色">
                    <CustomTag type="dark" :color="driverInfo.vehicleColor | filterConst('VEHICLECOLOR', 'color')">{{ driverInfo.vehicleColor || '-' }}</CustomTag>
                </el-descriptions-item>
                <el-descriptions-item label="核载人数">{{ driverInfo.vehicleSeat || '-' }}人</el-descriptions-item>
            </el-descriptions>
        </div>

        <el-tabs v-model="activeName" class="box driver-tabs">
            <el-tab-pane label="证件信息" name="info">
                <documnetInfo v-if="activeName === 'info'" :info="driverInfo" @refresh="getDriverInfo" />
            </el-tab-pane>
            <el-tab-pane label="钱包账户" name="account">
                <driverAccountPage v-if="activeName === 'account'" :info="driverInfo" @refresh="getDriverInfo" />
            </el-tab-pane>
            <el-tab-pane label="背景审核" name="background">
                <driverBackgroundPage v-if="activeName === 'background'" :driverInfo="driverBackgroundInfo"
                    :adverseRecord="adverseRecord" @submitSuccess="getAdverseRecord" />
            </el-tab-pane>

            <el-tab-pane label="监管数据" name="data" v-if="btnPreFn('travel_survey_driver', false)">
                <dataPage v-if="activeName === 'data'" :info="driverInfo" />
            </el-tab-pane>
            <el-tab-pane label="客运监管" name="supervise" v-if="btnPreFn('survey_driver', false)">
                <supervisePage v-if="activeName === 'supervise'" :info="driverInfo" />
            </el-tab-pane>
        </el-tabs>

        <el-drawer :visible.sync="showDzCreate" destroy-on-close :wrapperClosable="false" :before-close="handClose"
            size="50%">
            <DzCreate @success="handleSuccess" @cancel="handClose" :id="id" title="修改司机信息"></DzCreate>
        </el-drawer>
    </div>
</template>

<script>
import driverInfoDialog from "../components/detail/driverInfoDialog.vue";
import documnetInfo from "../components/detail/information/informationPage.vue";
import driverAccountPage from "../components/detail/driverAccount/driverAccountPage.vue";
import dataPage from "../components/detail/data/dataPage.vue";
import supervisePage from "../components/detail/supervise/supervisePage.vue";
import vehiclePage from "../components/detail/vehicle/vehiclePage.vue";
import driverBackgroundPage from "../components/detail/driverBackgroundPage/index.vue";
import DzCreate from '../list/DzCreate.vue'
export default {
    name: "dzDriverDetail",
    components: {
        documnetInfo,
        driverInfoDialog,
        driverAccountPage,
        dataPage,
        supervisePage,
        vehiclePage,
        driverBackgroundPage,
        DzCreate
    },
    data() {
        return {
            id: this.$route.query.id,
            activeName: 'info',
            driverInfo: {},
            driverBackgroundInfo: {},
            driverInfoDialogVisible: false,
            loading: false,
            editType: 'phone',
            adverseRecord: {},
            showDzCreate: false
        };
    },
    computed: {},

    watch: {
        activeName: {
            handler() {
                if (this.activeName === 'background') {
                    this.getAdverseRecord()
                }
            },
        }
    },
    created() {
        this.getDriverInfo();
    },

    methods: {
        handleSuccess() {
            this.showDzCreate = false;
            this.getDriverInfo();
        },
        handClose() {
            this.showDzCreate = false;
        },
        async getAdverseRecord() {
            let url = "/api/v1/manage/driver/adverse/record";
            const { code, data } = await this.$axios.get(url, {
                driverId: this.id,
            });
            if (code === 1) {
                this.adverseRecord = data;
            }
        },
        // 获取司机详情
        async getDriverInfo() {
            if (!this.id) {
                return false;
            } else {
                this.flag = false;
            }

            let url = "/api/v1/manage/driver/" + this.id;
            let { code, data } = await this.$axios.get(url);
            if (code === 1) {
                this.driverBackgroundInfo = {
                    id: data.id,
                    name: data.name,
                    idCard: data.idCard,
                    phone: data.phone,
                }
                this.driverInfo = {
                    ...data,
                    // idCardValid: data.idCardValid ? this.$utils.timeFn(data.idCardValid * 1000, "YYYY-MM-DD") : "",
                    idCardValidInput: data.idCardValid == 4102329600 ? "" :
                        data.idCardValid ? this.$utils.timeFn(data.idCardValid * 1000, "YYYY-MM-DD") : "",
                    driverLicenceValidInput: data.driverLicenceValid == 4102329600 ? "" :
                        data.driverLicenceValid ? this.$utils.timeFn(data.driverLicenceValid * 1000, "YYYY-MM-DD") : "",
                    qualificationsValidInput: data.qualificationsValid == 4102329600 ? "" :
                        data.qualificationsValid ? this.$utils.timeFn(data.qualificationsValid * 1000, "YYYY-MM-DD") : "",
                    firstIssueDate: data.firstIssueDate
                        ? this.$utils.timeFn(data.firstIssueDate * 1000, "YYYY-MM-DD")
                        : "",
                };
            }
        },
    },
};
</script>

<style lang="less" scoped>
.dzDriverDetail {
    display: flex;
    gap: 20px;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: var(--bg-color);

    &>.box {
        height: calc(100vh - 160px);
        background: #fff;
        padding: 20px;
        border-radius: 8px;
        overflow-y: auto;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);

        &::-webkit-scrollbar {
            width: 5px;
        }
    }

    .baseinfo {
        width: 380px;
        flex-shrink: 0;

        .info-header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 16px;
            border-bottom: 1px solid #ebeef5;
            margin-bottom: 8px;

            &-left {
                display: flex;
                align-items: center;
                font-size: 16px;
                font-weight: 600;
                color: #303133;

                .avatar {
                    width: 48px;
                    height: 48px;
                    border-radius: 50%;
                    overflow: hidden;
                    border: 2px solid #e4e7ed;
                }

                .name {
                    margin-left: 12px;
                }
            }
            
            .el-button {
                border-radius: 6px;
            }
        }

        .status-tag {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 6px;
        }

        :deep(.el-descriptions) {
            border-radius: 8px;
            position: relative;
            overflow: hidden;
            margin-top: 16px;
        }

        :deep(.el-descriptions)::after {
            content: '';
            pointer-events: none;
            position: absolute;
            inset: 0;
            border-radius: 8px;
            border: 1px solid #EBEEF5;
            z-index: 1;
        }
        
        :deep(.el-descriptions-row) {
            display: flex;
        }
        
        :deep(.el-descriptions-item__cell) {
            border-top: 0;
            border-left: 0;
        }
        
        :deep(.el-descriptions-item__label.is-bordered-label) {
            width: 110px;
            background-color: #f5f7fa;
            font-weight: 500;
            color: #606266;
        }

        :deep(.el-descriptions-item__content) {
            width: 260px;
            color: #303133;
        }    
    }

    .driver-tabs {
        flex: 1;
        
        /deep/ .el-tabs__header {
            margin-bottom: 16px;
        }
        
        /deep/ .el-tabs__item {
            font-size: 14px;
            
            &.is-active {
                font-weight: 500;
                color: #2B77FF;
            }
        }
        
        /deep/ .el-tabs__active-bar {
            background-color: #2B77FF;
        }
    }

    /deep/ .el-tabs__content {
        height: calc(100% - 60px);
        overflow-y: auto;
        padding-right: 20px;

        &::-webkit-scrollbar {
            width: 5px;
        }

        &>div {
            width: 100%;
            height: 100%;
        }
    }

    /deep/ .el-tabs__nav-wrap::after {
        height: 1px;
    }
}
</style>